module.exports = __webpack_public_path__ + "static/media/starter-stering-and-replacement-red.2cbb69a7.svg";